import React from "react";

// Partner / association logos shown in the scroller under the hero.
// Drop real PNG/SVG logos into /app/frontend/public/assets/partners/ with these
// exact filenames and they will replace the text fallbacks automatically.
const PARTNERS = [
  { name: "Tefla's", role: "Organised by", logo: "/assets/partners/teflas.png" },
  { name: "All India Distillers' Association (AIDA)", role: "Supported by", logo: "/assets/partners/supporter-1.png" },
  { name: "Global Ethanol Association", role: "Supported by", logo: "/assets/partners/supporter-2.png" },
  { name: "UP Distillers' Association (UPDA)", role: "Supported by", logo: "/assets/partners/supporter-3.png" },
];

function LogoTile({ p }) {
  const [err, setErr] = React.useState(false);
  return (
    <div className="mx-3 flex h-28 w-60 shrink-0 flex-col items-center justify-center rounded-2xl border border-border bg-white px-6 shadow-sm">
      {!err ? (
        <img src={p.logo} alt={p.name} onError={() => setErr(true)} className="max-h-16 max-w-[180px] object-contain" />
      ) : (
        <>
          <span className="text-[10px] font-semibold uppercase tracking-[0.18em] text-emeraldDeep">{p.role}</span>
          <span className="mt-1 text-center font-display text-sm font-semibold text-navy">{p.name}</span>
        </>
      )}
    </div>
  );
}

export default function PartnersMarquee() {
  const loop = [...PARTNERS, ...PARTNERS, ...PARTNERS, ...PARTNERS];
  return (
    <section className="border-b border-border bg-parchment py-10" data-testid="partners-marquee">
      <p className="mb-6 px-6 text-center text-xs font-semibold uppercase tracking-[0.2em] text-navy/50">
        Organised by Tefla's · Supported by leading associations
      </p>
      <div className="group relative overflow-hidden">
        <div className="pointer-events-none absolute inset-y-0 left-0 z-10 w-20 bg-gradient-to-r from-parchment to-transparent" />
        <div className="pointer-events-none absolute inset-y-0 right-0 z-10 w-20 bg-gradient-to-l from-parchment to-transparent" />
        <div className="flex w-max animate-marquee group-hover:[animation-play-state:paused]">
          {[...loop, ...loop].map((p, i) => <LogoTile key={i} p={p} />)}
        </div>
      </div>
    </section>
  );
}
